import { render, staticRenderFns } from "./LocationBusinessType.vue?vue&type=template&id=5b01ab69&"
import script from "./LocationBusinessType.vue?vue&type=script&lang=js&"
export * from "./LocationBusinessType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports